{
  "cms.catalog.action.createOption.banner": "Banneri",
  "cms.catalog.group.banner": "Bannerit",
  "cms.create.banner.heading": "Uusi banneri",
  "cms.create.banner.categoryMissing": "Sisältökategoriaa \"jasenyys\" ei löytynyt. Banneria ei voi luoda ennen kuin kategoria on olemassa.",
  "cms.form.banner.section.content": "Bannerin sisältö",
  "cms.form.banner.title": "Ylempi rivi",
  "cms.form.banner.subtitle": "Alempi rivi",
  "cms.form.banner.color": "Väri",
  "cms.form.banner.color.green": "Vihreä",
  "cms.form.banner.color.navy": "Tumma sininen",
  "cms.form.banner.color.red": "Punainen",
  "cms.form.banner.dismissible": "Sulje-nappi näkyvissä",
  "cms.form.banner.dismissible.help": "Käyttäjä voi sulkea bannerin.",
  "cms.form.banner.scope": "Näkyvyys",
  "cms.form.banner.scope.home": "Näytä vain etusivulla",
  "cms.form.banner.scope.sitewide": "Näytä kaikkialla",
  "cms.form.banner.error.titleRequired": "Ylempi rivi on pakollinen (enintään 120 merkkiä).",
  "cms.form.banner.error.titleNotDerivable": "Ylemmällä rivillä on oltava vähintään yksi latinalainen kirjain tai numero.",
  "cms.form.banner.error.subtitleTooLong": "Alempi rivi saa olla enintään 120 merkkiä.",
  "cms.form.banner.singletonRefused": "Kielellä on jo julkaistu banneri: {title}. Poista se julkaisusta tai korvaa se ennen julkaisua.",
  "cms.form.banner.singletonRefused.unnamed": "Kielellä on jo julkaistu banneri. Poista se julkaisusta tai korvaa se ennen julkaisua."
}
